function o() {
  let e = null, r = null;
  const l = new Promise((n, t) => {
    e = n, r = t;
  });
  return {
    resolve: e,
    reject: r,
    promise: l
  };
}
export {
  o as createResolver
};
